import { getLocalAccessToken } from "../../utils/helper";
import api, { handleErrorCreateAndUpdate } from "../../services/api";
import { Toast } from "../../components/notify/Notify";
import { url } from "../../constants/path";
const accessToken = getLocalAccessToken();

api.defaults.headers.common["Authorization"] = "Bearer " + accessToken;

const URL = url.systemAccessControl;

export const getAccessControls = (callback) => {
  api
    .get(URL)
    .then((response) => callback(response.data.data.list))
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};

export const getParentAC = (params = {}, callback) => {
  params = {
    page: 1,
    limit: 1000,
    ...params,
  };
  api
    .get(`${URL}/parent`, { params })
    .then((response) => callback(response.data.data))
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};

export const createAccessControl = (data, callback) => {
  api
    .post(URL, data)
    .then((response) => {
      Toast("success", "Thành công");
      callback(response.data.data);
    })
    .catch((err) => {
      handleErrorCreateAndUpdate(err, callback);
    });
};

export const getACDetail = (id, callback) => {
  api
    .get(`${URL}/${id}`)
    .then((response) => callback(response.data.data))
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};

export const getSubAccessControl = (id, params = {}, callback) => {
  api
    .get(`${URL}/child/${id}`, { params })
    .then((response) => callback(response.data.data))
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};

export const updateAccessControl = (id, data, callback) => {
  api
    .patch(`${URL}/${id}`, data)
    .then((response) => {
      Toast("success", "Thành công");
      callback(response);
    })
    .catch((err) => {
      // Toast("warning", err.response.data.message);
      handleErrorCreateAndUpdate(err, callback);
    });
};

export const removeAccessControl = (id, callback) => {
  api
    .delete(`${URL}/${id}`)
    .then((response) => {
      callback(response);
      Toast("success", "Thành công");
    })
    .catch((err) => {
      Toast("warning", err.response.data.message);
    });
};
